module.exports = __webpack_public_path__ + "static/media/najcredit.a140435f.svg";